<template>
    <div class="inner">
        <div class="inner-left">
            <div class="chart-con chart-con-1">
                <div class="chart-title">
                    <IconTitle :title="'国内学术研究相关情况'" :titleType="1" :link="'/xsdt/gnxs'" />
                </div>
                <div class="chart-con-main has-data-chart">
                    <div class="data-btn-list">
                        <ul>
                            <li class="item" v-for="item of learningData" :key="item.key" @click="showCurrTypeChart(item.key)">
                                <div class="item-count">
                                    <span>{{ revertNumber(item.value) }}</span>
                                </div>
                                <div class="item-title">
                                    <span>{{ item.name }}</span>
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div class="chart-place">
                        <div class="chart-place-main">
                            <div class="chart" id="chart1"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="chart-con chart-con-2">
                <div class="chart-title">
                    <IconTitle :title="'国内科研活动相关情况'" :titleType="1" :link="'/xsdt/zyxs'" />
                </div>
                <div class="chart-con-main">
                    <div class="chart chart-2" id="chart2"></div>
                </div>
            </div>
            <div class="chart-con chart-con-3">
                <div class="chart-con-main">
                    <div class="multi-chart double-chart">
                        <div class="chart-item">
                            <div class="chart" id="chart3"></div>
                            <span>按部门分R&D人数</span>
                        </div>
                        <div class="chart-item">
                            <div class="chart" id="chart4"></div>
                            <span>按地区分R&D人数</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="inner-right">
            <div class="chart-con chart-con-4">
                <div class="chart-title">
                    <IconTitle :title="'中外学术研究比较'" :titleType="1" :link="'/xsdt/zwxs'" />
                </div>
                <div class="chart-con-main">
                    <div class="chart" id="chart5"></div>
                </div>
            </div>
            <div class="chart-con chart-con-5">
                <div class="multi-chart three-chart">
                    <div class="chart-item">
                        <div class="chart" id="chart6"></div>
                        <span>{{ currSelectedYear }}发文量</span>
                    </div>
                    <div class="chart-item">
                        <div class="chart" id="chart7"></div>
                        <span>{{ currSelectedYear }}作者数</span>
                    </div>
                    <div class="chart-item">
                        <div class="chart" id="chart8"></div>
                        <span>{{ currSelectedYear }}被引量</span>
                    </div>
                </div>
            </div>
            <div class="chart-con chart-con-6">
                <div class="chart-title">
                    <IconTitle :title="'国内期刊发展情况'" :titleType="1" :link="'/xsdt/gnqk'" />
                </div>
                <div class="chart-con-main">
                    <div class="chart chart-9" id="chart9"></div>
                </div>
            </div>
        </div>
        <div class="inner-center">
            <div class="inner-center-main">
                <div class="inner-center-top">
                    <ul>
                        <li>
                            <div class="item-title">
                                发文量
                            </div>
                            <div class="item-count">
                                {{ currAreaData.post }}
                            </div>
                        </li>
                        <li>
                            <div class="item-title">
                                作者数
                            </div>
                            <div class="item-count">
                                {{ currAreaData.author }}
                            </div>
                        </li>
                        <li>
                            <div class="item-title">
                                被引量
                            </div>
                            <div class="item-count">
                                {{ currAreaData.quote }}
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="company-list company-list-l">
                    <span class="indicator-trianger"></span>
                    <div class="list" ref="learningList">
                        <ul>
                            <li v-for="(item,index) of learningArticleData" :key="index" :class="{ 'active': index == 4, 'prev': index == 3 || index == 5}" :data-url="item.url" :data-id="item.id">
                                <a target="_blank" :href="item.url" class="chartText">
                                    {{ item.title }}
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="earth">
                    <div class="earch-chart" id="earthChart"></div>
                    <div class="earch-bg"></div>
                </div>
                <div class="company-list company-list-r">
                    <span class="indicator-trianger"></span>
                    <div class="list" ref="hotWordsList">
                        <ul>
                            <li v-for="(item,index) of hotWordsData" :key="index" :class="{ 'active': index == 4, 'prev': index == 3 || index == 5}">
                                <span class="chartText">
                                    {{ item }}
                                </span>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="inner-center-btm">
                    <ul>
                        <li>
                            <div class="item-title">
                                篇均被引量
                            </div>
                            <div class="item-count">
                                {{ currAreaData.average }}
                            </div>
                        </li>
                        <li>
                            <div class="item-title">
                                每作者发文量
                            </div>
                            <div class="item-count">
                                {{ currAreaData.per_value }}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="tost" ref="tost" style="display: none;">
            <div class="tost-content">
                <img :src="descData.logo" alt="">
                <div class="tost-text">
                    <p>
                        {{ descData.title }}
                    </p>
                    <p class="tag">
                        <span v-for="item in descData.tagNameArr" :key="item">
                            {{ item }}
                        </span>
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import earthTexture from "@/assets/images/xsdt/earth-texture.jpg";
    import {
        learning,
        brokenLine,
        scientificActivity,
        learningChart,
        academicResearch,
        academicResearchChart,
        map,
        getPeriodical,
        hotWords,
        getLearningArticle
    } from '@/assets/scripts/api/xsdt';

    import IconTitle from '@/components/icontitle';
    const CHARTS_COLORS = ["#FC058F", '#EF9412', '#30CF70', '#05C1FC', '#0179FF', '#344ED5', '#01CDFF'];
    const PIE_COLORS = ["#FB058F", "#00CCFF", "#0078FF", "#344DD5",'#05C1FC','#0179FF'];
    const XAXIS_LINE_COLOR = '#344DD5';
    const TEXT_COLOR = '#B6C8FF';
    const TEXT_COLOR1 = '#4260FF';
    const labelColor = '#B5C8FF';
    const barColor = ['#344DD5', '#00CCFF'];
    const axisStyle = {
        splitLine: {
            lineStyle: {
                type: 'dotted',
                color: XAXIS_LINE_COLOR,
                opacity: 0.5
            }
        },
        axisLabel: {
            color: TEXT_COLOR
        },
        nameTextStyle: {
            color: TEXT_COLOR,
            fontSize: 12
        }
    };

    export default {
        name: 'XueShuDongTai',
        components: {
            IconTitle,
        },
        data() {
            return {
                hotWordsOptions: {
                    direction: 'vertical',
                    centeredSlides: true,
                    slidesPerView: 9,
                    spaceBetween: 20,
                    loop: true,
                    autoplay: {
                        disableOnInteraction:false,
                        delay: 3000
                    }
                },
                swiperOptions: {
                    direction: 'vertical',
                    centeredSlides: true,
                    slidesPerView: 9,
                    spaceBetween: 20,
                    loop: true,
                    autoplay: {
                        disableOnInteraction:false,
                        delay: 3000
                    },
                    on: {
                        click: () => {
                            // let {realIndex = 0} = this.mySwiper.swiperInstance;
                            // let { clientX, clientY } = e;

                            // this.descData = this.learningArticleData[realIndex];
                            // this.logo = "";
                            // this.$refs.tost.style.cssText = `left:${clientX}px;top:${clientY}px;display:block`

                            // setTimeout(() => {
                            //     this.$refs.tost.style.display = 'none';
                            // }, 3000)
                        }
                    }
                },
                descData: {},
                tostFlag: false,
                styles: {
                    left: 0,
                    top: 0
                },
                list: [],
                currSelectedYear: new Date().getFullYear(),
                learningData: {},
                brokenLineData: {},
                scientificActivityData: {},
                learningChartData: {},
                academicResearchData: {},
                // 右侧的三个饼图数据
                academicResearchChartData: {},
                // 国内期刊发展情况
                periodicalData: {},
                // 热词列表
                hotWordsData: [],
                // 资讯列表
                learningArticleData: [],
                // 地图数据
                mapData: {},
                // 当前地区的数据
                currAreaData: {
                    // 作者数
                    author: 0,
                    // 均被引
                    average: 0,
                    // 每作者发文数
                    per_value: 0,
                    // 发文数
                    post: 0,
                    // 被引量
                    quote: 0
                },
                scrollLeftTop: 0,
                scrollRightTop: 0
            }
        },
        created() {
            this.getEarthSurroundingList();
            this.init();
        },
        mounted() {
        },
        methods: {
            // 获取热词列表
            getEarthSurroundingList() {
                hotWords().then(({ data }) => {
                    this.hotWordsData = data;
                    this.$nextTick(() => {
                        this.$scrollTableDelay(this.$refs.hotWordsList);
                    });
                });
                getLearningArticle().then(({ data }) => {
                    this.learningArticleData = data;
                    this.$nextTick(() => {
                        this.$scrollTableDelay(this.$refs.learningList);
                    });
                });
                this.$winResize(()=> {
                    this.getEarthSurroundingList();
                });
            },
            init() {
                learning().then(({ data }) => {
                    this.learningData = data;
                })

                scientificActivity().then(({ data }) => {
                    this.scientificActivityData = data;
                    this.initChart2();
                })

                learningChart().then(({ data }) => {
                    this.learningChartData = data;
                    this.initChart3();
                    this.initChart4();
                })

                academicResearch().then(({ data }) => {
                    this.academicResearchData = data;
                    this.initChart5();
                })

                getPeriodical().then(({ data }) => {
                    this.periodicalData = data;
                    this.initChart9();
                })

                map().then(({ data }) => {
                    this.mapData = data;
                    this.initEarthChart();
                })

                academicResearchChart({ year: this.currSelectedYear }).then(({ data }) => {
                    this.academicResearchChartData = data;
                    this.initChart6();
                    this.initChart7();
                    this.initChart8();
                })

                this.getBrokenLineData();
            },
            // 显示当前类型的数据
            showCurrTypeChart(key) {

                this.getBrokenLineData(key);
            },
            getBrokenLineData(key = 1) {
                brokenLine({ key }).then(({ data }) => {
                    this.brokenLineData = data;
                    this.initChart1();
                })
            },
            initEarthChart() {
                const chart = echarts.init(document.getElementById("earthChart"));
                const canvas = document.createElement('canvas');
                const mapChart = echarts.init(canvas, null, {
                    width: 7096,
                    height: 2048
                });

                let pointData = this.mapData.map((item) => {
                    let {lat, lon,name } = item;

                    item.value = [lon, lat];
                    if(name == "中国"){
                        let {author,average,per_value,post,quote} = item;

                        this.currAreaData = {
                            author: this.revertNumber(author),
                            average: average,
                            per_value: per_value,
                            post: this.revertNumber(post),
                            quote: this.revertNumber(quote),
                        };
                    }
                    return item;
                });

                mapChart.setOption({
                    tooltip: {
                        show: true,
                        showContent: true,
                        trigger: 'item',
                        formatter: function(param) {
                            return param.name;
                        },
                    },
                    geo: {
                        show: false,
                        map: 'world',
                        zoom: 1,
                        label: {
                            emphasis: {
                                show: false
                            }
                        },
                        center: false,
                        itemStyle: {
                            color: "#8EA0FF",
                            normal: {
                                color: "#8EA0FF",
                                areaColor: "transparent"
                            },
                            emphasis: {

                                areaColor: "transparent"
                            }
                        },
                        nameMap: {
                            Afghanistan: '阿富汗',
                            Singapore: '新加坡',
                            Angola: '安哥拉',
                            Albania: '阿尔巴尼亚',
                            'United Arab Emirates': '阿联酋',
                            Argentina: '阿根廷',
                            Armenia: '亚美尼亚',
                            'French Southern and Antarctic Lands': '法属南半球和南极领地',
                            Australia: '澳大利亚',
                            Austria: '奥地利',
                            Azerbaijan: '阿塞拜疆',
                            Burundi: '布隆迪',
                            Belgium: '比利时',
                            Benin: '贝宁',
                            'Burkina Faso': '布基纳法索',
                            Bangladesh: '孟加拉国',
                            Bulgaria: '保加利亚',
                            'The Bahamas': '巴哈马',
                            'Bosnia and Herzegovina': '波斯尼亚和黑塞哥维那',
                            Belarus: '白俄罗斯',
                            Belize: '伯利兹',
                            Bermuda: '百慕大',
                            Bolivia: '玻利维亚',
                            Brazil: '巴西',
                            Brunei: '文莱',
                            Bhutan: '不丹',
                            Botswana: '博茨瓦纳',
                            'Central African Republic': '中非共和国',
                            Canada: '加拿大',
                            Switzerland: '瑞士',
                            Chile: '智利',
                            China: '中国',
                            'Ivory Coast': '象牙海岸',
                            Cameroon: '喀麦隆',
                            'Democratic Republic of the Congo': '刚果民主共和国',
                            'Republic of the Congo': '刚果共和国',
                            Colombia: '哥伦比亚',
                            'Costa Rica': '哥斯达黎加',
                            Cuba: '古巴',
                            'Northern Cyprus': '北塞浦路斯',
                            Cyprus: '塞浦路斯',
                            'Czech Republic': '捷克共和国',
                            Germany: '德国',
                            Djibouti: '吉布提',
                            Denmark: '丹麦',
                            'Dominican Republic': '多明尼加共和国',
                            Algeria: '阿尔及利亚',
                            Ecuador: '厄瓜多尔',
                            Egypt: '埃及',
                            Eritrea: '厄立特里亚',
                            Spain: '西班牙',
                            Estonia: '爱沙尼亚',
                            Ethiopia: '埃塞俄比亚',
                            Finland: '芬兰',
                            Fiji: '斐',
                            'Falkland Islands': '福克兰群岛',
                            France: '法国',
                            Gabon: '加蓬',
                            'United Kingdom': '英国',
                            Georgia: '格鲁吉亚',
                            Ghana: '加纳',
                            Guinea: '几内亚',
                            Gambia: '冈比亚',
                            'Guinea Bissau': '几内亚比绍',
                            Greece: '希腊',
                            Greenland: '格陵兰',
                            Guatemala: '危地马拉',
                            'French Guiana': '法属圭亚那',
                            Guyana: '圭亚那',
                            Honduras: '洪都拉斯',
                            Croatia: '克罗地亚',
                            Haiti: '海地',
                            Hungary: '匈牙利',
                            Indonesia: '印度尼西亚',
                            India: '印度',
                            Ireland: '爱尔兰',
                            Iran: '伊朗',
                            Iraq: '伊拉克',
                            Iceland: '冰岛',
                            Israel: '以色列',
                            Italy: '意大利',
                            Jamaica: '牙买加',
                            Jordan: '约旦',
                            Japan: '日本',
                            Kazakhstan: '哈萨克斯坦',
                            Kenya: '肯尼亚',
                            Kyrgyzstan: '吉尔吉斯斯坦',
                            Cambodia: '柬埔寨',
                            Kosovo: '科索沃',
                            Kuwait: '科威特',
                            Laos: '老挝',
                            Lebanon: '黎巴嫩',
                            Liberia: '利比里亚',
                            Libya: '利比亚',
                            'Sri Lanka': '斯里兰卡',
                            Lesotho: '莱索托',
                            Lithuania: '立陶宛',
                            Luxembourg: '卢森堡',
                            Latvia: '拉脱维亚',
                            Morocco: '摩洛哥',
                            Moldova: '摩尔多瓦',
                            Madagascar: '马达加斯加',
                            Mexico: '墨西哥',
                            Macedonia: '马其顿',
                            Mali: '马里',
                            Myanmar: '缅甸',
                            Montenegro: '黑山',
                            Mongolia: '蒙古',
                            Mozambique: '莫桑比克',
                            Mauritania: '毛里塔尼亚',
                            Malawi: '马拉维',
                            Malaysia: '马来西亚',
                            Namibia: '纳米比亚',
                            'New Caledonia': '新喀里多尼亚',
                            Niger: '尼日尔',
                            Nigeria: '尼日利亚',
                            Nicaragua: '尼加拉瓜',
                            Netherlands: '荷兰',
                            Norway: '挪威',
                            Nepal: '尼泊尔',
                            'New Zealand': '新西兰',
                            Oman: '阿曼',
                            Pakistan: '巴基斯坦',
                            Panama: '巴拿马',
                            Peru: '秘鲁',
                            Philippines: '菲律宾',
                            'Papua New Guinea': '巴布亚新几内亚',
                            Poland: '波兰',
                            'Puerto Rico': '波多黎各',
                            'North Korea': '北朝鲜',
                            Portugal: '葡萄牙',
                            Paraguay: '巴拉圭',
                            Qatar: '卡塔尔',
                            Romania: '罗马尼亚',
                            Russia: '俄罗斯',
                            Rwanda: '卢旺达',
                            'Western Sahara': '西撒哈拉',
                            'Saudi Arabia': '沙特阿拉伯',
                            Sudan: '苏丹',
                            'South Sudan': '南苏丹',
                            Senegal: '塞内加尔',
                            'Solomon Islands': '所罗门群岛',
                            'Sierra Leone': '塞拉利昂',
                            'El Salvador': '萨尔瓦多',
                            Somaliland: '索马里兰',
                            Somalia: '索马里',
                            'Republic of Serbia': '塞尔维亚',
                            Suriname: '苏里南',
                            Slovakia: '斯洛伐克',
                            Slovenia: '斯洛文尼亚',
                            Sweden: '瑞典',
                            Swaziland: '斯威士兰',
                            Syria: '叙利亚',
                            Chad: '乍得',
                            Togo: '多哥',
                            Thailand: '泰国',
                            Tajikistan: '塔吉克斯坦',
                            Turkmenistan: '土库曼斯坦',
                            'East Timor': '东帝汶',
                            'Trinidad and Tobago': '特里尼达和多巴哥',
                            Tunisia: '突尼斯',
                            Turkey: '土耳其',
                            Uganda: '乌干达',
                            Ukraine: '乌克兰',
                            Uruguay: '乌拉圭',
                            'United States': '美国',
                            Uzbekistan: '乌兹别克斯坦',
                            Venezuela: '委内瑞拉',
                            Vietnam: '越南',
                            Vanuatu: '瓦努阿图',
                            'West Bank': '西岸',
                            Yemen: '也门',
                            'South Africa': '南非',
                            Zambia: '赞比亚',
                            Korea: '韩国',
                            Tanzania: '坦桑尼亚',
                            Zimbabwe: '津巴布韦',
                            Congo: '刚果',
                            'Central African Rep.': '中非',
                            Serbia: '塞尔维亚',
                            'Bosnia and Herz.': '波黑',
                            'Czech Rep.': '捷克',
                            'W. Sahara': '西撒哈拉',
                            'Lao PDR': '老挝',
                            'Dem.Rep.Korea': '朝鲜',
                            'Falkland Is.': '福克兰群岛',
                            'Timor-Leste': '东帝汶',
                            'Solomon Is.': '所罗门群岛',
                            Palestine: '巴勒斯坦',
                            'N. Cyprus': '北塞浦路斯',
                            Aland: '奥兰群岛',
                            'Fr. S. Antarctic Lands': '法属南半球和南极陆地',
                            Mauritius: '毛里求斯',
                            Comoros: '科摩罗',
                            'Eq. Guinea': '赤道几内亚',
                            'Guinea-Bissau': '几内亚比绍',
                            'Dominican Rep.': '多米尼加',
                            'Saint Lucia': '圣卢西亚',
                            Dominica: '多米尼克',
                            'Antigua and Barb.': '安提瓜和巴布达',
                            'U.S. Virgin Is.': '美国原始岛屿',
                            Montserrat: '蒙塞拉特',
                            Grenada: '格林纳达',
                            Barbados: '巴巴多斯',
                            Samoa: '萨摩亚',
                            Bahamas: '巴哈马',
                            'Cayman Is.': '开曼群岛',
                            'Faeroe Is.': '法罗群岛',
                            'IsIe of Man': '马恩岛',
                            Malta: '马耳他共和国',
                            Jersey: '泽西',
                            'Cape Verde': '佛得角共和国',
                            'Turks and Caicos Is.': '特克斯和凯科斯群岛',
                            'St. Vin. and Gren.': '圣文森特和格林纳丁斯'
                        }
                    }
                }, true);

                const option = {
                    backgroundColor: 'transparent',
                    globe: {
                        zIndex: 0,
                        left: 0,
                        top: 0,
                        right: 0,
                        bottom: 0,
                        baseTexture: earthTexture,
                        // heightTexture:earthTexture,
                        // displacementTexture:earthTexture,
                        // displacementScale: 0.01,
                        shading: 'color',
                        // environment: environmentTexture,
                        environment: 'none',
                        colorMaterial: {
                            //detailTexture:earthLayer,
                            roughness: 0.8,
                            textureTiling: 1
                        },
                        postEffect: {
                            enable: true,
                            SSAO: {
                                enable: true,
                                radius: 2,
                                intensity: 1.5,
                                quality: 'high'
                            }
                        },
                        temporalSuperSampling: {
                            enable: true
                        },
                        light: {
                            ambient: {
                                intensity: 0
                            },
                            main: {
                                intensity: 1,
                                shadow: false,
                                color: '#fff'
                            },
                            ambientCubemap: {
                                //texture: hdrFile,
                                exposure: 1,
                                diffuseIntensity: 0.2
                            }
                        },
                        viewControl: {
                            center: [0, 0, 0],
                            autoRotate: true,
                            alpha: 10,
                            autoRotateSpeed: 3.6,
                            beta: 120,
                            autoRotateAfterStill: 5,
                            distance: 150,
                            minDistance: 150,
                            maxDistance: 150
                        },
                        layers: [{
                            type: 'blend',
                            texture: mapChart,
                            show: false
                        }]
                    },
                    series: [{
                        type: 'scatter3D',
                        blendMode: 'source-over',
                        coordinateSystem: 'globe',
                        effectType: 'ripple',
                        // showEffectOn: 'render',
                        // rippleEffect: {
                        //     period: 2,
                        //     scale: 5,
                        //     brushType: 'fill'
                        // },
                        symbolSize: 15,
                        hoverAnimation: false,
                        itemStyle: {
                            normal: {
                                color: '#00CCFF'
                            }
                        },
                        label: {
                            normal:{
                                textStyle:{
                                    fontSize:24,
                                    fontWeight:500,
                                    color:'#000'
                                },
                            },
                            emphasis: {

                                formatter: function (param) {
                                    return param.name;
                                },
                            }
                        },
                        data: pointData,
                        silent: false,
                    }]
                }

                chart.setOption(option, true);
                chart.resize();

                this.$winResize(chart.resize);

                chart.on("click", (event) => {
                    let { data = {}, componentSubType } = event;
                    if (componentSubType === 'scatter3D') {
                        let { author = 0, average = 0, per_value = 0, post = 0, quote = 0 } = data;

                        this.currAreaData = {
                            author: this.revertNumber(author),
                            average: average,
                            per_value: per_value,
                            post: this.revertNumber(post),
                            quote: this.revertNumber(quote),
                        };
                    }
                });
            },
            initChart1() {
                const chart = echarts.init(document.getElementById("chart1"));
                let nameArr = [],
                    valueArr = [];

                this.brokenLineData.map((item) => {
                    nameArr.push(item[0]);
                    valueArr.push(item[1]);
                });
                const option = {
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    grid: {
                        left: 0,
                        right: 20,
                        bottom: 0,
                        top: 0,
                        containLabel: true
                    },
                    xAxis: Object.assign({}, axisStyle, {
                        axisLine: { show: false },
                        splitLine: { show: false },
                        axisLabel: {
                            color: TEXT_COLOR,
                            formatter: (item) => {
                                return this.revertNumber(item);
                            },
                        },
                        type: "value",
                    }),
                    yAxis: Object.assign({
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: { show: false },
                        data: nameArr,
                        type: 'category'
                    }, axisStyle),
                    series: [{
                        type: 'bar',
                        data: valueArr,
                        barWidth: 20,
                        itemStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 1,
                                y2: 0,
                                colorStops: [{
                                    offset: 0,
                                    color: PIE_COLORS[3] // 0% 处的颜色
                                }, {
                                    offset: 1,
                                    color: PIE_COLORS[1] // 100% 处的颜色
                                }],
                            }
                        }
                    }]
                };

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart2() {
                const { title, column, list } = this.scientificActivityData;

                const chart = echarts.init(document.getElementById("chart2"));
                const option = {
                    tooltip: {
                        trigger: 'axis'
                    },
                    legend: {
                        data: title || ['R&D经费支出(亿元)', "占GDP比重(%)"],
                        textStyle: {
                            color: TEXT_COLOR
                        },
                        icon: "circle",
                        itemWidth: 6,
                        bottom: 0
                    },
                    grid: {
                        left: 50,
                        right: 50,
                        top: 10,
                        bottom: 60
                    },
                    xAxis: Object.assign({}, axisStyle, {
                        axisLine: {
                            lineStyle: { color: XAXIS_LINE_COLOR },
                            onZero: false
                        },
                        axisLabel: {
                            color: TEXT_COLOR1
                        },
                        boundaryGap: true,
                        data: column,
                        type: 'category'
                    }),
                    yAxis: [Object.assign({}, axisStyle, {
                        axisLine: { show: false },
                        type: "value",
                        axisLabel: { color: TEXT_COLOR1 },
                    }), Object.assign({}, axisStyle, {
                        axisLine: { show: false },
                        splitLine: {
                            show: false
                        },
                        axisLabel: { color: TEXT_COLOR1 },
                        axisTick: {
                            alignWithLabel: true
                        },
                        type: "value"
                    })],
                    series: [{
                        type: 'line',
                        name: "R&D经费支出(亿元)",
                        // stack: '总量',
                        smooth: true,
                        yAxisIndex:0,
                        itemStyle: {
                            color: CHARTS_COLORS[3],
                            borderWidth: 1
                        },
                        data: list[0]
                    }, {
                        type: 'line',
                        name: "占GDP比重(%)",
                        // stack: '总量',
                        yAxisIndex: 1,
                        smooth: true,
                        itemStyle: {
                            color: CHARTS_COLORS[0],
                            borderWidth: 1
                        },
                        data: list[1]
                    }]
                };
                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            getMultiPieOpt({ list }) {
                let seriesData = [],
                    option = {},
                    title = {};

                title = {
                    text: this.revertNumber(list.reduce((total, curr) => parseFloat(total) + parseFloat(curr.value), 0)),
                    top: 'center',
                    left: 'center',
                    textStyle: {
                        color: TEXT_COLOR,
                        fontSize: 14
                    }
                }
                seriesData = list;
                option = {
                    color: PIE_COLORS,
                    title: title,
                    tooltip: {
                        trigger: 'item',
                        formatter: "{b} : {c} ({d}%)"
                    },
                    series: [{
                        type: 'pie',
                        center: ['50%', '50%'],
                        radius: ['70%', '90%'],
                        hoverOffset:5,
                        label: {
                            show: false
                        },
                        data: seriesData
                    }]
                };
                return option;
            },
            initChart3() {
                const chart = echarts.init(document.getElementById("chart3"));
                let { left: leftData } = this.learningChartData;
                let pieData = {
                    title: "按部门分R&D人数",
                    list: leftData
                }
                chart.setOption(this.getMultiPieOpt(pieData), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart4() {
                const chart = echarts.init(document.getElementById("chart4"));
                let { right: rightData } = this.learningChartData;
                let pieData = {
                    title: "按地区分R&D人数",
                    list: rightData
                }

                chart.setOption(this.getMultiPieOpt(pieData), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart5() {
                const chart = echarts.init(document.getElementById("chart5"));
                const { title = [], list = [], column = [] } = this.academicResearchData;
                let seriesData = [];
                let $that = this;
                const baseSeriesDataOpt = {
                    type: 'line',
                    // stack: '总量',
                    smooth: true,
                    itemStyle: {
                        borderWidth: 6
                    },
                    symbol: 'circle'
                }
                list.forEach((item, index) => {
                    seriesData.push(Object.assign({}, baseSeriesDataOpt, { name: title[index], data: item.map(item=>parseFloat(item)) }));
                })
                const option = {
                    color: CHARTS_COLORS,
                    tooltip: {
                        trigger: 'axis'
                    },
                    title: {
                        text: "发文量环比增速",
                        left: 0,
                        top: 0,
                        textStyle: {
                            color: TEXT_COLOR,
                            fontSize: 14
                        }
                    },
                    legend: {
                        data: title,
                        textStyle: {
                            color: TEXT_COLOR,
                            fontSize: 12
                        },
                        icon: "circle",
                        itemWidth: 6,
                        bottom: 0,
                    },
                    grid: {
                        left: '10%',
                        right: '10%',
                        top: 40,
                        bottom: '17%'
                    },
                    xAxis: Object.assign({}, axisStyle, {
                        axisLabel: {
                            color: TEXT_COLOR1
                        },
                        axisLine: {
                            lineStyle: { color: XAXIS_LINE_COLOR },
                            onZero: false
                        },
                        boundaryGap: false,
                        data: column,
                        type: 'category',
                        triggerEvent: true
                    }),
                    yAxis: Object.assign({}, axisStyle, {
                        axisLabel: {
                            color: TEXT_COLOR1
                        },
                        axisLine: { show: false },
                        type: "value"
                    }),
                    series: seriesData
                };

                chart.setOption(option, true);
                chart.on('click', function (params) {
                    if(params.componentType == 'xAxis') {
                        $that.currSelectedYear = params.value;

                        academicResearchChart({ year: $that.currSelectedYear }).then(({ data }) => {
                            $that.academicResearchChartData = data;
                            $that.initChart6();
                            $that.initChart7();
                            $that.initChart8();
                        })
                    }
                });
                chart.resize();
                this.$winResize(chart.resize);
            },
            changeData(data) {
                let arr = [];

                data.forEach((item) => {
                    let obj = {};

                    obj.name = item.title;
                    obj.value = item.value;
                    arr.push(obj);
                })

                return arr;
            },
            initChart6() {
                const chart = echarts.init(document.getElementById("chart6"));
                const { post: postData } = this.academicResearchChartData;
                const pieData = {
                    title: this.currSelectedYear+"发文量",
                    list: this.changeData(postData)
                }

                chart.setOption(this.getMultiPieOpt(pieData), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart7() {
                const chart = echarts.init(document.getElementById("chart7"));
                const { author: authorData } = this.academicResearchChartData;

                const pieData = {
                    title: this.currSelectedYear+"作者数",
                    list: this.changeData(authorData)
                }

                chart.setOption(this.getMultiPieOpt(pieData), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart8() {
                const chart = echarts.init(document.getElementById("chart8"));
                const { citation: citationData } = this.academicResearchChartData;
                const pieData = {
                    title: this.currSelectedYear+"被引量",
                    list: this.changeData(citationData)
                }

                chart.setOption(this.getMultiPieOpt(pieData), true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            initChart9() {
                let { title = [], column = [], list = [] } = this.periodicalData;
                let chart = echarts.init(document.getElementById('chart9')),
                    seriesData = [],
                    option = "";


                list.forEach((item, index) => {
                    seriesData.push({
                        type: 'bar',
                        barWidth: 20,
                        barGap: '10%',
                        name: title[index],
                        itemStyle: {
                            normal: {
                                show: true,
                                color: barColor[index]
                            }
                        },
                        data: item
                    });
                });

                option = {
                    color: barColor,
                    tooltip: {
                        trigger: 'axis',
                    },
                    legend: {
                        itemWidth: 12,
                        itemHeight: 12,
                        itemGap: 20,
                        top: 0,
                        right: 0,
                        textStyle: {
                            color: labelColor,
                            fontSize: 12,
                            margin: 7
                        },
                        name: title,
                        icon: 'rect',
                    },
                    grid: {
                        left: 20,
                        top: 40,
                        bottom: 0,
                        right: 0,
                        containLabel: true
                    },
                    xAxis: Object.assign({}, axisStyle, {
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            color: TEXT_COLOR1,
                            fontSize: 14
                        },
                        axisLine: {
                            lineStyle: { color: XAXIS_LINE_COLOR }
                        },
                        data: column,
                        splitLine: { show: false },
                    }),
                    yAxis: Object.assign({}, axisStyle, {
                        axisTick: {
                            show: false
                        },
                        axisLabel: {
                            color: TEXT_COLOR1,
                            fontSize: 14
                        },
                        axisLine: {
                            show: false
                        },
                        type: 'value',
                        formatter: "{value}"
                    }),
                    series: seriesData
                };

                chart.setOption(option, true);
                chart.resize();
                this.$winResize(chart.resize);
            },
            addNumberComma(val) {
                var len = val.length;
                var valArr = [];
                var currCount = 0;
                var splitSize = 3;

                while (--len >= 0) {
                    currCount++;
                    valArr.push(val[len]);
                    if (currCount === splitSize && len) {
                        currCount = 0;
                        valArr.push(",");
                    }
                }
                return valArr.reverse().join("");
            },
            revertNumber(val) {
                var numberVal = Number(val);
                var showVal = val + "";
                var pointerPart = showVal.split(".")[1] || [];

                if (typeof val == 'undefined') {
                    return "";
                }
                if (numberVal > 10000) {
                    showVal = this.addNumberComma(String(Math.round(numberVal / 1000))) + 'k';
                } else {
                    showVal = this.addNumberComma(showVal);
                } 
                return pointerPart.length ? showVal  : showVal;
            }
        }
    }
</script>
<style lang="scss" scoped>
@import "@/assets/scss/mixins/_mixins.scss";

$labelColor: #ffbf2e;
$titleColor: #B5C8FF;
$borderColor: #17215F;
$borderDrakColor: #080B26;
$textYellow: #ffc02f;
$textBlue: #3f91f5;

.inner {
    padding: 0 2.08%;

    >div {
        height: 94.8%;
    }

    &-left,
    &-right {
        width: 22.3369%;

    }

    &-left {
        float: left;
    }

    &-right {
        float: right;
    }

    &-center {
        margin: 0 25.054%;
    }
}

.chart-con-main {
    margin-top: 0.2rem;
    // margin-bottom: 0.3rem;

    &.has-data-chart {
        overflow: hidden;

        .chart-place {
            float: left;
            height: 100%;
            width: 100%;
            margin-right: -1.6rem;
            margin-left: 0.2rem;

            &-main {
                margin-right: 1.6rem;
                height: 100%;

                .chart {
                    height: 100%;
                }
            }
        }
    }
}

.data-btn-list {
    float: left;
    height: 100%;

    ul {
        height: 100%;

        .item {
            width: 1.4rem;
            height: 16.5%;
            margin-bottom: 0.2rem;
            background-image: repeating-linear-gradient(45deg, transparent, transparent 2px, #1F2972 2px, #1F2972 4px, transparent 4px, transparent 6px);
            text-align: center;
            cursor: pointer;
            overflow: hidden;

            span {
                display: inline-block;
                line-height: 1;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width: 90%;
            }

            &-count {
                line-height: 1;
                font-size: 0.24rem;
                color: #B5C8FF;
                margin: 12% auto 6%;
            }

            &-title {
                font-size: 0.16rem;
                color: #4260FF;
            }
        }
    }

}

.multi-chart {
    width: 100%;
    height: 100%;

    &.double-chart {
        margin-left: 0.61rem;
        margin-right: 0.61rem;

        .chart-item {
            margin-right: 0.5rem;
        }
    }

    &.three-chart {
        margin-bottom: 0.2rem;

        .chart-item {

            &:nth-of-type(2) {
                margin: 0 8%;
            }
        }
    }

    .chart-item {
        height: 100%;
        width: 27.76%;
        float: left;
        font-size: 0.16rem;
        color: #B5C8FF;
        text-align: center;

        .chart {
            width: 100%;
        }
    }
}

.inner-center {
    .inner-center-main {
        float: left;
        width: 100%;
        margin-top: 1.5rem;
        height: 69.565%;
        position: relative;

        .inner-center-top,
        .inner-center-btm {
            width: 50.1%;
            height: 1.5rem;
            font-size: 0.24rem;
            position: absolute;
            left: 50%;
            margin-left: -25.05%;
            text-align: center;
            background: url("~@/assets/images/xsdt/lens-top.png") no-repeat center/100% 100%;

            ul {
                display: inline-block;
                margin-top: 0.22rem;
                transition: all 0.5;
            }

            li {
                float: left;
                color: #B5C8FF;
                line-height: 1;
                font-weight: 600;

                &:nth-of-type(2):not(:last-child) {
                    margin: 0 0.8rem;
                }

                .item-title {
                    color: #4260FF;
                    font-size: 0.2rem;
                    margin-bottom: 0.08rem;
                }
            }
        }

        .inner-center-top {
            top: -1.3rem;
        }

        .inner-center-btm {
            bottom: -1.3rem;
            transform: rotate(180deg);

            ul {
                transform: rotate(-180deg);

                li {
                    &:first-child {
                        margin-right: 0.25rem;
                    }

                    &:last-child {
                        margin-left: .25rem;
                    }
                }
            }
        }

        .earth {
            position: absolute;
            left: 0.38rem;
            right: 0.38rem;
            top: -0.88rem;
            bottom: -0.88rem;
            background: url("~@/assets/images/xsdt/earth-bg.png") no-repeat center/cover;

            .earch-chart,
            .earch-bg {
                position: absolute;
                width: 6.8rem;
                height: 6.8rem;
                left: 50%;
                top: 50%;
                margin-left: -3.4rem;
                margin-top: -3.4rem;
            }

            .earch-bg {
                pointer-events: none;
               /* background: url("~@/assets/images/xsdt/map-mask.png") no-repeat center/4.6rem;*/
            }
        }

        .company-list {
            height: 100%;
            position: relative;
            font-size: 0.16rem;
            z-index: 3;
            .chartText{
                display: inline-block;
                width:2rem;
                line-height: 0.48rem;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                color: #3a49cf;
            }
            .indicator-trianger {
                position: absolute;
                top: 50%;
                width: 0.46rem;
                height: 0.52rem;
                margin-top: -0.26rem;
                background: url("~@/assets/images/xsdt/earth-gap-trigangel.png") no-repeat center/cover;
            }

            &:before {
                content: "";
                position: absolute;
                height: 100%;
                background: url("~@/assets/images/xsdt/earth-gap-line.png") no-repeat center/cover;
                width: 0.17rem;
            }

            .list {
                position: absolute;
                top: 50%;
                margin-top: -2.25rem;
                height: 4.6rem;
                overflow: hidden;
                li{
                    &.active{
                        a, span{
                            color: #fff;
                        }
                     }
                    &.prev{
                        a, span{
                            color: #abb3ff;
                        }
                     }
                }
            }

            .swiper-wrapper {

                .swiper-slide {
                    cursor: pointer;
                    margin-bottom: 0.3rem;
                    max-width: 11em;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    color: #3A49CF;

                    &.swiper-slide-active {
                        span,a{
                            color: #FFFFFF;
                        }
                    }

                    &.swiper-slide-prev,
                    &.swiper-slide-next {
                        span,a{
                            color: #ABB3FF;
                        }
                    }

                    a {
                        line-height: 1;
                        display: block;
                        color: #3A49CF;
                    }
                }
            }

            &-l {
                float: left;

                .indicator-trianger {
                    left: -0.27rem;
                }

                &:before {
                    left: 0;
                }

                .list {
                    left: 0;
                    padding-left: 0.28rem;

                    li {
                        cursor: pointer;
                    }
                }
            }

            &-r {
                float: right;
                text-align: right;

                .indicator-trianger {
                    right: -0.27rem;
                    transform: rotate(180deg);
                }

                &:before {
                    right: 0;
                    transform: rotate(180deg);
                }

                .list {
                    right: 0;
                    padding-right: 0.28rem;
                }
            }
        }
    }
}

.chart-con {
    margin-bottom: 3%;

    &-1 {
        height: 47.46%;

        .chart-con-main {
            height: 82.6%;
        }
    }

    &-2 {
        height: 32.5%;

        .chart-con-main {
            height: calc(100% - 0.3rem);
            // margin-top:0.3rem;
        }
    }

    &-3 {
        height: 15.625%;
        margin-top: 12%;

        .chart-con-main {
            height: 100%;

            .chart {
                height: calc(100% - 26px);
            }
        }
    }

    &-4 {
        height: 42.93%;

        .chart-con-main {
            height: 82.8%;
        }
    }

    &-5 {
        height: 15.657%;
        margin-top: 5%;

        .chart {
            height: calc(100% - 26px);
        }
    }

    &-6 {
        margin-top: 5%;
        height: 40.11%;

        .chart-con-main {
            height: 80.58%;
        }
    }
}

.tost {
    padding: .2rem;
    width: 4rem;
    height: auto !important;
    overflow: hidden;
    border: 1px solid $borderColor;
    color: $titleColor;
    background: rgba(0, 0, 0, .7);
    z-index: 99;
    font-size: .16rem;
    @include position(absolute, 40px, -100%, auto, auto);

    .tost-content {
        overflow: hidden;

        img {
            width: 1rem;
            height: 1rem;
            float: left;
        }

        .tost-text {
            margin-left: 1.2rem;

            p {
                line-height: 2;
            }

            .tag {
                span {
                    display: inline-block;
                    font-size: .14rem;
                    margin: .2rem .2rem 0 0;
                }
            }
        }
    }

}

.tost-hide {
    visibility: hidden;
}

.chart {
    height: 100%;
}
</style>